import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { selectQuotationForm } from "app/containers/WorkOrder/redux/selector";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import { useStyles } from "../styles";

const ReadOnlyField = ({
  labelKey,
  value,
  currency,
}: {
  labelKey: string;
  value: string;
  currency?: boolean;
}) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Box className={styles.fieldMetric}>
      <Typography className={styles.fieldMetricLabel}>{t(labelKey)}</Typography>
      <Typography className={styles.fieldMetricValue}>
        {currency ? (
          <span dir="ltr">
            {t(formKey("ROOF_CURTAINS.CURRENCY"), { amount: value })}
          </span>
        ) : (
          value
        )}
      </Typography>
    </Box>
  );
};

const QuoteCosts = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const form = useSelector(selectQuotationForm);

  return (
    <Box className={styles.sectionsCard}>
      <Box className={styles.formSection}>
        <Box className={styles.sectionHeaderPlain}>
          <Typography className={styles.sectionTitle}>
            {t(formKey("SECTIONS.BASE_COSTS"))}
          </Typography>
        </Box>
        <Box className={styles.grid4}>
          <ReadOnlyField
            labelKey={formKey("FIELDS.WORK_HOURS")}
            value={form.workHours}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.PER_HOUR")}
            value={form.perHour}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.TOTAL_WORK_COST")}
            value={form.totalWorkCost}
            currency
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.REPAIR_HOURS")}
            value={form.repairHours}
          />
        </Box>
      </Box>

      <Box className={styles.formSection}>
        <Box className={styles.sectionHeader}>
          <Typography className={styles.sectionTitle}>
            {t(formKey("SECTIONS.PARAMETERS_COEFFICIENTS"))}
          </Typography>
        </Box>
        <Box className={styles.grid6}>
          <ReadOnlyField
            labelKey={formKey("FIELDS.SHEET_METAL_COST_BLACK")}
            value={form.sheetMetalCost}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.EXCHANGE_RATE")}
            value={form.dollarRate}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.ESTIMATED_WEIGHT")}
            value={form.estimatedWeight}
            currency
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.CALCULATED")}
            value={form.calculated}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.COEFFICIENTS")}
            value={form.coefficients}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.CURTAIN_PART")}
            value={form.curtainPart}
          />
        </Box>
      </Box>

      <Box className={styles.formSection}>
        <Box className={styles.sectionHeader}>
          <Typography className={styles.sectionTitle}>
            {t(formKey("SECTIONS.SALE_DETAILS"))}
          </Typography>
        </Box>
        <Box className={styles.grid4}>
          <ReadOnlyField
            labelKey={formKey("FIELDS.CURTAIN_AND_ADVERTISING")}
            value={form.curtainAndAdvertising}
            currency
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.CURTAIN_WITHOUT_BARRIER")}
            value={form.curtainWithoutBarrier}
            currency
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.ADVERTISING_WITHOUT_CURTAIN")}
            value={form.advertisingWithoutCurtain}
            currency
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.WITHOUT_CURTAIN_WITHOUT_ADVERTISING")}
            value={form.withoutCurtainWithoutAdvertising}
            currency
          />
        </Box>
      </Box>
    </Box>
  );
};

export default QuoteCosts;
